var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBulb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16675 7.00033H1.8149M7.00008 1.16699V1.81514M12.1853 7.00033H12.8334M2.85193 2.85218L3.30564 3.30588M11.1482 2.85218L10.6945 3.30588M5.50931 10.2411H8.49079M5.05564 9.59292C4.5115 9.18481 4.10956 8.61585 3.90675 7.96661C3.70394 7.31737 3.71055 6.62078 3.92564 5.97551C4.14073 5.33024 4.5534 4.769 5.10519 4.3713C5.65697 3.97359 6.31991 3.75958 7.00008 3.75958C7.68026 3.75958 8.34319 3.97359 8.89498 4.3713C9.44676 4.769 9.85943 5.33024 10.0745 5.97551C10.2896 6.62078 10.2962 7.31737 10.0934 7.96661C9.89061 8.61585 9.48867 9.18481 8.94453 9.59292C8.69147 9.84342 8.50093 10.15 8.38833 10.4878C8.27573 10.8256 8.24423 11.1851 8.29638 11.5374C8.29638 11.8812 8.1598 12.2109 7.9167 12.454C7.6736 12.6971 7.34388 12.8337 7.00008 12.8337C6.65628 12.8337 6.32656 12.6971 6.08346 12.454C5.84036 12.2109 5.70378 11.8812 5.70378 11.5374C5.75593 11.1851 5.72443 10.8256 5.61183 10.4878C5.49923 10.15 5.30869 9.84342 5.05564 9.59292Z",
    stroke: "#0857C3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulb);
export default __webpack_public_path__ + "static/media/Bulb.dc41c023438a7df09443337fbf5106f2.svg";
export { ForwardRef as ReactComponent };